import { z } from 'zod';
import { capitalize } from '../../utils/capitalize.js';
import { requiredUuidString } from '../zod-helpers/index.js';
import { CUSTOMER_LICENSE_CONSTRAINTS as LIMITS } from './constraints.js';
/** New Customer's duplicate check: a license number and the state that issued it. */
export const customerLicenseMatchArgsSchema = z.object({
    licenseNumber: z
        .string()
        .trim()
        .min(1, `${capitalize(LIMITS.licenseNumber.label.toLowerCase())} is required.`)
        .max(LIMITS.licenseNumber.maxLength),
    stateId: requiredUuidString(`${capitalize(LIMITS.stateId.label.toLowerCase())} is required.`, 'Invalid state.'),
});
//# sourceMappingURL=license-match-args.js.map